(function () {
  function initYalgo(root) {
    if (!root || root.dataset.yalgoReady === 'true') return;
    root.dataset.yalgoReady = 'true';

    root.querySelectorAll('[data-yalgo-faq]').forEach(function (item) {
      var button = item.querySelector('.yalgo-faq-button');
      if (!button) return;
      button.addEventListener('click', function () {
        var isOpen = item.classList.toggle('is-open');
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var selector = link.getAttribute('href');
        if (!selector || selector === '#') return;
        var target = root.querySelector(selector) || document.querySelector(selector);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    var values = root.querySelectorAll('[data-count-target]');
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.dataset.counted === 'true') return;
        el.dataset.counted = 'true';

        var target = el.dataset.countTarget || '';
        var match = target.match(/^(\d+)(.*)$/);
        if (!match) return;
        var end = parseInt(match[1], 10);
        var suffix = match[2] || '';
        var startTime = null;
        var duration = 850;

        function tick(time) {
          if (!startTime) startTime = time;
          var p = Math.min((time - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(end * eased) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
        observer.unobserve(el);
      });
    }, { threshold: .35 });

    values.forEach(function (el) { observer.observe(el); });
  }

  function boot() {
    document.querySelectorAll('[data-yalgo-root]').forEach(initYalgo);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-yalgo-root]');
    if (root) initYalgo(root);
  });
})();
